import React from 'react';
import './styles/ConditionBadge.css';
import CreateProductConfigHelper from '../../services/helpers/CreateProductConfigHelper';

interface ConditionBadgeProps {
  listingType?: string;
  condition?: string;
  className?: string;
}

const USED_LISTING_LABEL = 'Used Product';

// Keyed by lower-cased condition. The key doubles as the CSS modifier class.
const CONDITION_LABELS: Record<string, string> = {
  like_new: 'Like New',
  excellent: 'Excellent',
  good: 'Good',
  fair: 'Fair',
  poor: 'Poor',
};

/**
 * Listing-type pill, plus a condition pill for Used listings only. Condition
 * is ignored for every other type even when the backend populates it.
 */
const ConditionBadge: React.FC<ConditionBadgeProps> = ({ listingType, condition, className = '' }) => {
  if (!listingType) return null;

  const listingTypeLabel = CreateProductConfigHelper.listingTypeIdToLabel(listingType);
  const conditionKey = condition?.toLowerCase() ?? '';
  const conditionLabel =
    listingTypeLabel === USED_LISTING_LABEL ? CONDITION_LABELS[conditionKey] : undefined;

  return (
    <div className={`badge-container ${className}`.trim()}>
      <div className="condition-badge listing-type">
        <span>{listingTypeLabel}</span>
      </div>

      {conditionLabel && (
        <div className={`condition-badge ${conditionKey}`}>
          <span>{conditionLabel}</span>
        </div>
      )}
    </div>
  );
};

export default React.memo(ConditionBadge);
